import React from 'react'
import { Button, Form, Modal } from 'semantic-ui-react'
import { SearchFolios } from '../../api/services/finance'
import { DatePicker } from '../../components/shared/DatePicker'
import { useTextResources } from '../../language'
import GridSearchTemplate from '../GridSearchTemplate'
import PropTypes from "prop-types";

const TransferToFolioPopup = ({reservation, onCancel, HotelID, ...rest})=>{
    const text = useTextResources()
    const options = {
        search: {
            title: "Search Folio",
            description: "Search folio to transfer to...",
            api: SearchFolios,
            fields: [ 
                <DatePicker 
                    type="basic"
                    label= {text("StartDate")} 
                    name="StartDate"
                    key="StartDate"
                />,
                <DatePicker 
                    type="basic"
                    label= {text("EndDate")}
                    name="EndDate"
                    key="EndDate"
                />,
                <Form.Input name="FolioId" key="FolioId" label={text("FolioNumber")}/>,
                <Form.Input name ="ReservationNumber"key="ReservationNumber" label={text("ReservationNumber")}/>,
                <Form.Input key="OwnerName" label={text("OwnerName")}/>
            ],
            initial: {
                ReservationNumber: reservation?reservation.Number:null
            },
            searchOnLoad: true,
            groupSize: 4,
            spec: {
                HotelId: HotelID
            }
        },
        grid: {
            columns: [
                { name: 'Number', title: 'Number' },
                { name: 'OwnerName', title: 'Owner Name' },
                { name: 'ReservationNumber', title: 'Reservation Number' },
                { name: 'Balance', title: 'Balance' }
            ]
        }
    }
    return <Modal size="large" {...rest}>
        <Modal.Header>{text("Transfertoanyfolio")}</Modal.Header>
        <Modal.Content>
            <GridSearchTemplate options={options}></GridSearchTemplate>
        </Modal.Content>
        <Modal.Actions>
            <Button negative size="small" onClick={onCancel}>{text("Cancel")}</Button>
            <Button positive size="small">{text("OK")}</Button>
        </Modal.Actions>
    </Modal>
}

TransferToFolioPopup.propTypes = {
    reservation: PropTypes.any,
    onCancel: PropTypes.any,
    HotelID: PropTypes.any
}
export default TransferToFolioPopup